<template>
    <svg :width="`${size}px`" :height="`${size}px`" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="m12 40 4-4V1c0-.55-.45-1-1-1H9c-.55 0-1 .45-1 1v35l4 4z" fill="#000" />
        <path
            ref="fillPathRef"
            :class="fillClass"
            d="M34.33 21.5a.98.98 0 0 1-.93.44L1.08 19.09c-.58-.05-.99-.59-.9-1.16l.8-4.78c.02-.1.02-.2 0-.31L.15 7.08a1 1 0 0 1 .93-1.14L33.4 4.06c.37-.04.72.13.93.44l5.3 7.95c.22.34.22.77 0 1.11l-5.3 7.95v-.01z"
        />
        <path
            ref="outlinePathRef"
            :class="outlineClass"
            d="m39.63 12.45-5.3-7.95a.98.98 0 0 0-.93-.44L16 5.07V1c0-.55-.45-1-1-1H9c-.55 0-1 .45-1 1v4.53l-6.91.4a1 1 0 0 0-.93 1.14l.82 5.77c.01.1.01.2 0 .31l-.8 4.78a1 1 0 0 0 .9 1.16L8 19.7V36l4 4 4-4V20.41l17.4 1.53c.37.03.72-.13.93-.44l5.3-7.95c.22-.34.22-.77 0-1.11v.01zM9 1h6v4.13l-6 .35V1zm6 34.59-3 3-3-3V19.8l6 .53v15.26zm18.5-14.64L1.16 18.1l.8-4.78c.03-.2.04-.4 0-.6l-.83-5.78 32.32-1.88 5.34 7.95-5.3 7.95.01-.01z"
        />
    </svg>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { collectionPinProps, useCollectionPinComponent } from '../../composables/useCollection';
import { CollectionType } from 'ihunter-common';

const props = defineProps({
    ...collectionPinProps(CollectionType.Track),
});

const { size, fillClass, outlineClass, initializeStyleFillColor, initializeStyleOutlineColor } = useCollectionPinComponent(props);

const fillPathRef = ref(null);
const outlinePathRef = ref(null);

onMounted(() => {
    initializeStyleFillColor(fillPathRef);
    initializeStyleOutlineColor(outlinePathRef);
});
</script>

<style lang="scss" scoped>
@use 'ihunter-pathfinder/styles' as Pathfinder;

@include Pathfinder.Pin;
</style>
